import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActionGuard, LoginGuard } from '../../../core/_infrastructure/classes/guards/main.guard';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { PeriodoAmbitoWrapperEditComponent } from './ambito/ambito-wrapper-edit/ambito-wrapper-edit.component';
import { PeriodoCamWrapperComponent } from './datosbasicos/periodo-wrapper/periodo-wrapper.component';
import { PeriodoCamWrapperEditComponent } from './datosbasicos/periodocam-wrapper-edit/periodocam-wrapper-edit.component';
import { DatosCaWrapperEditComponent } from './datosca/datosca-wrapper-edit/datosca-wrapper-edit.component';
import { DatosCaWrapperComponent } from './datosca/datosca-wrapper/datosca-wrapper.component';
import { InspeccionesWrapperEditComponent } from './inspecciones/inspecciones-wrapper-edit/inspecciones-wrapper-edit.component';
import { InspeccionesWrapperComponent } from './inspecciones/inspecciones-wrapper/inspecciones-wrapper.component';
import { PeriodosVariedadWrapperComponent } from './periodos-variedades/periodos-variedad-wrapper/periodos-variedad-wrapper.component';
import { PlazosWrapperEditComponent } from './plazos/plazos-wrapper-edit/plazos-wrapper-edit.component';
import { PlazosWrapperComponent } from './plazos/plazos-wrapper/plazos-wrapper.component';
import { AccessPeriodoCamGuard } from './_classes/access.guard';

const periodoCamRoutes: Routes = [
    //PERIODOS
    {
        path: 'mantenimiento/periodos',
        data: {
            breadcrumb: 'Periodos',
            menu0: 'MANTENIMIENTO', //,
            //menu1: 'Buscadores'
        },

        children: [
            {
                path: '',
                component: PeriodoCamWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.PERIODOS,
                },
            },
            {
                path: 'datosbasicos/create',
                component: PeriodoCamWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'datosbasicos/edit/:id',
                component: PeriodoCamWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard(), AccessPeriodoCamGuard()],
                data: {
                    breadcrumb: 'Editar',
                    actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_PERIODO,
                },
            },
            {
                path: 'plazos/:id',
                component: PlazosWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'plazos/:id/create',
                component: PlazosWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'plazos/:id/edit/:idplazo',
                component: PlazosWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'inspecciones/:id',
                component: InspeccionesWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'inspecciones/:id/create',
                component: InspeccionesWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'inspecciones/:id/edit/:idinspeccion',
                component: InspeccionesWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'listadatosca/:id',
                //component: DatosCaWrapperComponent,
                //canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
                children: [
                    {
                        path: '',
                        component: DatosCaWrapperComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                            breadcrumb: 'Lista CA',
                        },
                    },
                    {
                        path: 'edit/:idconf',
                        component: DatosCaWrapperEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                            breadcrumb: 'Detalle CA',
                        },
                    },
                ],
            },
            {
                //path: 'datosca2/:id/edit/:idconf',
                path: 'datosca/:id',
                component: DatosCaWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard(), AccessPeriodoCamGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_CA_Y_ENTIDADES,
                    breadcrumb: 'Detalle CA',
                },
            },
            {
                path: 'ambito/:id',
                component: PeriodoAmbitoWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'especies/:id',
                component: PeriodosVariedadWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(periodoCamRoutes)],
    exports: [RouterModule],
})
export class PeriodosRoutingModule {}
